import { createContext, useState } from "react";

export const AirCoolerContext = createContext();

export function AirCoolerProvider({ children }) {

  const [coolerData, setCoolerData] = useState({
    "A-101A": { speed: 0, running: false, mode: "Manual" },
    "A-101B": { speed: 0, running: false, mode: "Manual" }
  });

  const updateCooler = (tag, newData) => {
    setCoolerData(prev => ({
      ...prev,
      [tag]: {
        ...prev[tag],
        ...newData
      }
    }));
  };

  return (
    <AirCoolerContext.Provider value={{ coolerData, updateCooler }}>
      {children}
    </AirCoolerContext.Provider>
  );
}